import Multiselects from './multiselects'
import Tabs from './tabs'
import DatePickers from './datepickers'
import Toggles from './toggles'
import GeolocInput from './geoloc-input'
import VueApp from './vue-app'
import Toast from "./toast"
import Axios from "axios"
import Cookies from 'js-cookie'
import Modals from './modals';
import AvatarEditor from "./avatar-editor";
window.$ = window.jQuery = $;

window.addEventListener('load', function () {
    let menu = $('.menu--main');
    let userMenu = $('.menu--user');

    function setup() {
        menuShow();
        playVideo();
    }

/*    $(".slider--header").slick({ dots: true, arrows: false });*/
    $(".multi-range").ionRangeSlider();

    function menuShow() {
        $(".menu__action").click(function(event) {
            event.preventDefault();
            menu.toggleClass("menu--open");
            $(".menu__action").toggleClass("action--hide");

        });

        $(".menu__user-link").click(function(event) {
            event.preventDefault();
            userMenu.toggleClass("menu--open");
        });

        $(".search__close").click(function(event) {
            event.preventDefault();
            $(".menu__form").toggleClass("menu--open");
        });
    }

    function playVideo() {
        $(".video__play").click(function(event) {
            event.preventDefault();
            $(".section__video video").get(0).play();
            $(".section__video video").attr("controls", true);
            $(this).hide();

        });
    }

    setup();

    DatePickers();
    Toggles();
    Tabs();
    Multiselects();
    GeolocInput();
    Modals();
    VueApp();
    AvatarEditor()
    Toast();

    // toggle dark-mode
    if(document.querySelector('.js-dark-mode')) {
        document.querySelector('.js-dark-mode').addEventListener('click', function() {
            Cookies.set('has_dark_mode',
                // use return value of classList.toggle
                document.querySelector('body').classList.toggle('dark-mode') ? 'dark-mode' : 'light-mode'
            );
        })
    }

    // toggle big-text
    if(document.querySelector('.js-big-text')) {
        document.querySelector('.js-big-text').addEventListener('click', function() {
            Cookies.set('has_big_text',
                // use return value of classList.toggle
                document.querySelector('body').classList.toggle('big-text') ? 'big-text' : 'medium-text'
            );
        })
    }

    // localisation type selector
    if(document.querySelector('.localisation-type-selector')) {
        document.querySelector('.localisation-type-selector').addEventListener('change', function( event ) {
            if(event.target.value === 'distance') {
                document.querySelectorAll('.localisation-type-region').forEach( element => element.classList.add('hide'));
                document.querySelectorAll('.localisation-type-distance').forEach( element => element.classList.remove('hide'));
            }

            if(event.target.value === 'region') {
                document.querySelectorAll('.localisation-type-distance').forEach( element => element.classList.add('hide'));
                document.querySelectorAll('.localisation-type-region').forEach( element => element.classList.remove('hide'));
            }
        });
    }

    // like button
    document.querySelectorAll('.like-button').forEach(function( like_button ) {
        like_button.addEventListener('click', function( event ) {
            // Could be toggled here to avoid unresponsive behaviour
            event.preventDefault();
            let user_slug = this.getAttribute('user_slug');

            Axios.get(user_slug + '/like')
                 .then( () => like_button.classList.toggle('-active'))
                 .catch( error => console.warn(error) )
        });
    });

    // more member pagination
    if(document.querySelector('.more-member-button')) {
        document.querySelector('.more-member-button').addEventListener('click', function( event ) {
            event.preventDefault();

            let current_page = Number(this.getAttribute('current_page'));
            let last_page = Number(this.getAttribute('last_page'));
            let next_page = current_page + 1;
            //TODO: parametrize url to call
            Axios.get('/membres?page=' + next_page)
                 .then( function( success ) {
                    let parser = new DOMParser();
                    let html = parser.parseFromString(success.data, 'text/html');

                    let new_members_nodes = html.querySelector('.profiles__list').childNodes;
                    document.querySelector('.profiles__list').append(...new_members_nodes);

                    event.target.setAttribute('current_page', next_page);

                    if(next_page + 1 > last_page) {
                        event.target.classList.add('hide');
                    }
                })
                 .catch( error => console.warn(error))
        });
    }

   if(document.querySelector('.search-form')) {
        document.querySelector('.search-form').addEventListener('change', function( event ){
            this.submit();
        })
   }
});
